import * as actions from "./user.actions";
import * as types from "./user.actionTypes";
import { ActionType, createReducer } from "typesafe-actions";
import { UserReducerType } from "./types";

export type UserActions = ActionType<typeof actions>;

export const initialState: UserReducerType = {
  error: null,
  listUser: [],
  isLoading: false,
  errorMessage: "",
  redirectQueue: '',
  selectedUser: null,
};

export const UserReducer = createReducer<
UserReducerType,
  UserActions
>(initialState)
  // GET JENIS DOKUMEN
  .handleAction(actions.getUserAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: ''
  }))
  .handleAction(actions.getUserAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    errorMessage: '',
    listUser: action.payload.data.items,
  }))
  .handleAction(actions.getUserAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // GET JENIS DOKUMEN
  .handleAction(actions.getDetailUserAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: '',
  }))
  .handleAction(actions.getDetailUserAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    errorMessage: '',
    selectedUser: action.payload.data,
  }))
  .handleAction(actions.getDetailUserAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // UPDATE JENIS DOKUMEN
  .handleAction(actions.updateUserAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    redirectQueue: '',
    errorMessage: '',
  }))
  .handleAction(actions.updateUserAsync.success, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    isLoading: false,
  }))
  .handleAction(actions.updateUserAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // CREATE JENIS DOKUMEN
  .handleAction(actions.createUserAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: '',
  }))
  .handleAction(actions.createUserAsync.success, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    isLoading: false,
    redirectQueue: '/user-control',
  }))
  .handleAction(actions.createUserAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // OTHER SELECTORS
  .handleAction(types.INITIALIZE_CREATE_USER as any, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    selectedUser: action.payload.user,
  }))
  
  .handleAction(types.SELECT_USER as any, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    redirectQueue: '',
    selectedUser: action.payload.user,
  }))

  .handleAction(types.UPDATE_STATUS as any, (state, action) => ({
    ...state,
    selectedUser: (() => {
      if (state.selectedUser) {
        return {
          ...state.selectedUser,
          STATUS: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))

  .handleAction(types.UPDATE_EMPLOYEE as any, (state, action) => ({
    ...state,
    selectedUser: (() => {
      if (state.selectedUser) {
        return {
          ...state.selectedUser,
          NIK: action.payload.newId,
          NIK_DETAIL: action.payload.newDetail
        };
      } else {
        return null;
      }
    })(),
  }))

  .handleAction(types.UPDATE_ROLE as any, (state, action) => ({
    ...state,
    selectedUser: (() => {
      if (state.selectedUser) {
        return {
          ...state.selectedUser,
          ROLE_ID: action.payload.newId,
          ROLE_DETAIL: action.payload.newDetail
        };
      } else {
        return null;
      }
    })(),
  }))
